import { useState, type CSSProperties } from "react";
import { PageHeader, Icon } from "@/components/admin-ui";

// Settings is a stub today — the FE shows the nav so reviewers can see
// what's coming, but the right pane is intentionally a "coming soon"
// placeholder. The previous build rendered fake editable Fields,
// Toggles, and DangerRow buttons that did nothing; that was worse than
// being honest. Wire-up lands together with the /admin/settings
// endpoint + migration in a follow-up backend pass.

export function SettingsPage() {
  const [section, setSection] = useState("General");

  return (
    <>
      <PageHeader
        kicker="System"
        title="Settings"
        sub="Operator-facing knobs. Tenant-wide settings live in tenant.toml — these will override at runtime once persistence ships."
      />

      <div style={{ padding: "0 26px 26px", display: "grid", gridTemplateColumns: "220px 1fr", gap: 26 }}>
        {/* Side index — kept so the eventual section layout is discoverable. */}
        <nav style={{ position: "sticky", top: 0, alignSelf: "start" }}>
          {[
            "General",
            "Editorial workflow",
            "Data engine",
            "Authentication",
            "Notifications",
            "API tokens",
            "Danger zone",
          ].map((label) => {
            const on = label === section;
            return (
              <button
                key={label}
                onClick={() => setSection(label)}
                type="button"
                style={{
                  display: "block", width: "100%", textAlign: "left",
                  padding: "7px 11px", borderRadius: 7, border: "none",
                  background: on ? "var(--accent-soft)" : "transparent",
                  color: on ? "var(--accent)" : "var(--ink-2)",
                  fontFamily: "var(--font-ui)", fontSize: 12.5,
                  fontWeight: on ? 500 : 400, cursor: "pointer",
                  marginBottom: 2,
                }}
              >
                {label}
              </button>
            );
          })}
        </nav>

        <div style={emptyCard}>
          <span style={{ color: "var(--ink-3)", display: "inline-flex", marginBottom: 12 }}>
            {Icon.alert}
          </span>
          <h2 style={emptyH}>{section} — coming soon</h2>
          <p style={emptyP}>
            Persistence for tenant settings lands with the next backend pass
            (POST <code style={code}>/admin/settings</code> + migration).
            Until then this page is intentionally read-only — running production
            settings live in <code style={code}>tenant.toml</code> and the
            relevant environment variables.
          </p>
          <p style={emptyP}>
            For changes today, edit <code style={code}>tenant.toml</code>, push to
            main, and redeploy. The deploy.yml workflow propagates env-var
            changes automatically.
          </p>
        </div>
      </div>
    </>
  );
}

const emptyCard: CSSProperties = {
  border: "1px dashed var(--rule)", borderRadius: 12,
  background: "var(--surface)", padding: "44px 28px",
  textAlign: "center",
};
const emptyH: CSSProperties = {
  fontFamily: "var(--font-serif)", fontSize: 22, fontWeight: 500,
  letterSpacing: "-0.02em", margin: "0 0 10px", color: "var(--ink)",
};
const emptyP: CSSProperties = {
  fontFamily: "var(--font-serif)", fontSize: 13.5, fontStyle: "italic",
  color: "var(--ink-3)", lineHeight: 1.6, margin: "8px auto",
  maxWidth: 520,
};
const code: CSSProperties = {
  fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--ink-2)",
  background: "var(--surface-2)", padding: "1px 5px", borderRadius: 4,
  fontStyle: "normal",
};
